import { useMemo } from "react";
import { useIntl } from "react-intl";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import { createStandardColumns, StandardColumnIds } from "./helpers/columnUtils";

const labelStyle = {
  "&.MuiFormControlLabel-root": {
    m: 0,
  },
  "& .MuiFormControlLabel-label": {
    fontSize: "12px",
    lineHeight: "normal",
    m: 1,
    ml: -0.5,
    px: 0,
    py: 0.5,
  },
  "& .MuiSvgIcon-root": {
    fontSize: "1.25rem",
  },
};

const ColumnVisibilitySelector = ({
  columns,
  onToggleColumn,
  sx,
  viewColumnIds,
  visibleColumnIds,
}) => {
  const intl = useIntl();

  const selectableColumns = useMemo(() => createStandardColumns(intl).filter(n => n.fieldId !== StandardColumnIds.TASK_NAME), [intl]);

  return (
    <FormGroup row sx={{ flexWrap: "wrap", ...sx }}>
      {
        [
          ...selectableColumns,
          ...(columns || []),
        ].filter(n => (viewColumnIds || []).includes(n.fieldId))
          .map((col) => (
            <FormControlLabel
              control={
                <Checkbox
                  checked={visibleColumnIds.includes(col.fieldId)}
                  onClick={() => onToggleColumn?.(col.fieldId)}
                />
              }
              key={col.fieldId}
              label={col.label}
              sx={labelStyle}
            />
          ))
      }
    </FormGroup>
  );
};

export default ColumnVisibilitySelector;
